const StoreIncentive = () => import('@/views/Incentive/storeIncentive/index')
const StoreInvitationCreate = () => import('@/views/Incentive/create')
const PointsExchange = () => import('@/views/Incentive/pointsExchange')
const PointsDetail = () => import('@/views/Incentive/pointsDetail')
const Incentive = () => import('@/views/Incentive')
const IncentiveDetail = () => import('@/views/Incentive/detail/index')
const IncentiveOpenStoe = () => import('@/views/Incentive/openStoe')
const IncentiveSearch = () => import('@/views/Search/IncentiveSearch')

const incentiveRouter = [
  {
    path: '/storeIncentive',
    component: StoreIncentive,
    meta: {
      title: 'Store Incentive'
    }
  },
  {
    path: '/storeIncentive/create',
    component: StoreInvitationCreate,
    meta: {
      title: 'Store Incentive Create'
    }
  },
  {
    path: '/pointsExchange',
    component: PointsExchange,
    meta: {
      title: 'Points Exchange'
    }
  },
  {
    path: '/pointsDetail',
    component: PointsDetail,
    meta: {
      title: 'Points Detail'
    }
  },
  {
    path: '/incentive/incentiveDetail',
    component: IncentiveDetail,
    meta: {
      title: 'incentive Detail'
    }
  },
  {
    path: '/incentive/openStoe',
    component: IncentiveOpenStoe,
    meta: {
      title: 'Open Store'
    }
  },
  {
    path: '/incentive',
    component: Incentive,
    meta: {
      title: 'Incentive'
    }
  },
  {
    path: '/incentive/incentiveSearch',
    component: IncentiveSearch,
    meta: {
      title: 'Incentive Search'
    }
  }
]

export default incentiveRouter
